// Boot-time "restore last-active character" routine. Bridges the
// localStorage pointer (persistence/last-active) and the in-memory store
// so a page reload re-activates the slot the player last used instead of
// dropping them to "No active character".
//
// Kept out of App.tsx so the entrypoint stays a pure component module
// (react-refresh) and so tests can drive this to completion deterministically.
//
// Phase 3 Step 10d-ux-polish.

import {
  clearLastActiveId,
  loadCharacter,
  readLastActiveId,
} from '../persistence/index.js';
import { useActiveCharacterStore } from './active-character';

/**
 * Restore the last-active character from the localStorage pointer.
 *
 * Guards:
 *  - Race: if the player manually Activates a slot while `loadCharacter` is in
 *    flight, the store's `active` is no longer null — defer to that choice and
 *    skip the restore.
 *  - Missing id: a pointer to a deleted record clears the stale key.
 */
export async function restoreActiveCharacter(): Promise<void> {
  const id = readLastActiveId();
  if (id === null) return;

  const record = await loadCharacter(id);
  if (record === undefined) {
    clearLastActiveId();
    return;
  }
  // Only restore if nothing was activated while we were loading.
  if (useActiveCharacterStore.getState().active === null) {
    useActiveCharacterStore.getState().activate(record);
  }
}
